export default "__VITE_ASSET__d390bf0c__"